<mat-accordion>
<div mat-dialog-content class="dialog-content">
<h2 mat-dialog-title>Audit Trail</h2>
<mat-form-field>
  <input
    matInput
    (keyup)="applyFilter($event.target.value)"
    maxlength="20"
    placeholder="Search"
  />
  <!-- <i class="material-icons">search</i> -->
  <br>
  <br>
</mat-form-field>

<button mat-raised-button
      type="submit"
      (click)="exportexcel()"
      class="mat-raised-button-excel" color="primary">
      Excel Report</button>
      
      <!-- <button><img src='https://svgshare.com/i/ux7.svg' title='' /></button>
      <button><img src='https://svgshare.com/i/Gwo.svg' title='' /></button>
      <mat-icon svgIcon="my-star-icon"></mat-icon> -->

      <!-- <button mat-raised-button color="accent">
        <mat-icon>mic</mat-icon> Start Recording
      </button> -->

      <!-- <button mat-button><mat-icon>excel</mat-icon></button>
      <button><img src='https://svgshare.com/i/Gwo.svg' title='' /></button>
      <button><img src='https://icons8.de/icon/13654/ms-excel.svg' title='' /></button>
    <mat-icon>mic</mat-icon>-->
     
    

<table id= "excel-table" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

  <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

  <!-- Position Column -->
  <ng-container matColumnDef="date_change">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
    <td mat-cell *matCellDef="let element" ng-non-bindable> {{element.date_change | date:'yyyy.MM.dd HH:mm:ss '}} </td>
  </ng-container>

 <!-- Name Column -->
  <ng-container matColumnDef="username">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> User </th>
    <td mat-cell *matCellDef="let element"> {{element.username}} </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="module">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Module </th>
    <td mat-cell *matCellDef="let element"> {{element.module}} </td>
  </ng-container>

   <!-- Symbol Column -->
   <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
    <td mat-cell *matCellDef="let element"> {{element.action}} </td>
  </ng-container>

   <!-- Symbol Column -->
   <ng-container matColumnDef="table_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Table </th>
    <td mat-cell *matCellDef="let element"> {{element.table_name}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<br>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="10"></mat-paginator>
</div>
<div mat-dialog-actions class="alignRight">
  <button mat-raised-button class="mat-raised-button" color="primary" (click)="closeDialog()">CLOSE</button>     
</div>
</mat-accordion>